import { CampaignControlOptionApiGroup } from '@/Enums/ControlOptions/CampaignGroup.enum';
import { ICampaign } from '@/Interfaces/Campaign.interface';
import { IControlOption, IGroupedControlOption } from '@/Interfaces/ControlOption.interface';

// Response handler of CAMPAIGNS_LIST_ENDPOINT
export const getOptionsFromCampaignsList = (campaignsList: ICampaign[]): IControlOption[] => {
  if (!campaignsList?.length) {
    return [];
  }

  return campaignsList
    .map(campaign => ({
      value: campaign.id,
      label: campaign.name,
    }))
    .sort((a, b) => a.label?.toLowerCase().localeCompare(b.label?.toLowerCase()));
};

export const getGroupedCampaignOptions = (campaigns: ICampaign[], groupValue?: string): IGroupedControlOption[] => {
  if (!campaigns?.length) {
    return [];
  }

  return campaigns
    .map(campaign => ({
      value: campaign.id,
      label: campaign.name,
      groupLabel: CampaignControlOptionApiGroup.Beeswax,
      groupValue,
    }))
    .sort((a, b) => a.label?.toLowerCase().localeCompare(b.label?.toLowerCase()));
};
